export default "__VITE_ASSET__5jjkld4V__"